export default __webpack_public_path__ + "static/media/kit_svg4.7173b98d.svg";